module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"title":"Rediger leverandør","name":"Navn","type":"Type","address":"Addresse","postalCode":"Postkode","postalPlace":"Sted"},"en":{"title":"Edit vendor","name":"Name","type":"Type","address":"Address","postalCode":"Postalcode","postalPlace":"Place"}}')
  delete Component.options._Ctor
}
